import { Property } from "@/features/survey/types";
import { Link } from "react-router";
import PropertyMarker from "./PropertyMarker";

interface PropertyMenuItemProps {
  property: Property;
  surveyId: string;
  properties?: Property[];
  onClick?: () => void;
  variant?: "desktop" | "mobile";
}

const PropertyMenuItem = ({
  property,
  surveyId,
  properties = [],
  onClick,
  variant = "desktop",
}: PropertyMenuItemProps) => {
  const linkClassName =
    variant === "desktop"
      ? "block px-4 py-2 text-sm hover:bg-gray-100 transition-colors"
      : "block px-3 py-2 text-sm text-gray-300 hover:text-green-300 transition-colors";

  return (
    <Link
      to={`/interactive/${surveyId}/property/${property.id}`}
      onClick={onClick}
      className={linkClassName}
      style={variant === "desktop" ? { color: "var(--color-data)" } : undefined}
    >
      <div className="flex items-center space-x-3">
        <PropertyMarker property={property} properties={properties} size="sm" />
        <div className="flex-1 min-w-0">
          <div className="font-medium truncate">
            {property.propertyName ||
              property.name ||
              `Property ${property.id}`}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PropertyMenuItem;
